import React from 'react';
import { Link } from 'react-router-dom';
import './ComingSoon.css';

interface ComingSoonProps {
  pageTitle?: string;
  className?: string;
}

const ComingSoon: React.FC<ComingSoonProps> = ({ 
  pageTitle = 'Página',
  className = '' 
}) => {
  return (
    <div className={`coming-soon ${className}`}>
      <div className="coming-soon__container">
        {/* Alere Logo */}
        <div className="coming-soon__logo">
          <img 
            src="/alere-logo-56586a.png" 
            alt="Alere Café"
            className="coming-soon__logo-img"
          />
        </div>

        {/* Main Content */}
        <div className="coming-soon__content">
          <h1 className="coming-soon__title">
            ¡Próximamente!
          </h1>
          
          <p className="coming-soon__subtitle">
            Esta página estará disponible pronto
          </p>
          
          <div className="coming-soon__description">
            <p>
              Estamos trabajando en traerte la mejor experiencia en <strong>{pageTitle}</strong>.
            </p>
            <p>
              Mientras tanto, puedes disfrutar de nuestro <Link to="/blog" className="coming-soon__link">blog</Link> con las últimas noticias y artículos sobre café.
            </p>
          </div>

          {/* Call to Action */}
          <div className="coming-soon__cta">
            <Link to="/blog" className="coming-soon__button">
              Ver nuestro Blog
            </Link>
          </div>
        </div>

        {/* Decorative Elements */}
        <div className="coming-soon__decorative">
          <div className="coming-soon__decorative-circle coming-soon__decorative-circle--1"></div>
          <div className="coming-soon__decorative-circle coming-soon__decorative-circle--2"></div>
          <div className="coming-soon__decorative-circle coming-soon__decorative-circle--3"></div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;